import { useEffect, useState } from 'react';
export const useOptionsWidth = ({ inputRef }) => {
    const [width, setWidth] = useState(undefined);
    useEffect(() => {
        if (inputRef.current)
            setWidth(inputRef.current.getBoundingClientRect().width);
        const onResize = () => {
            if (inputRef.current) {
                setWidth(inputRef.current.getBoundingClientRect().width);
            }
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [inputRef]);
    return width;
};
